var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-dots"}},[_c('div',{staticClass:"loader-dots",style:({'color': _vm.object,'font-size': _vm.size+'px'})})])}
var staticRenderFns = []

export { render, staticRenderFns }